module.exports = __webpack_public_path__ + "media/15.0a0637b4.mp3";